import { Component, EventEmitter, Input, NgModule, OnInit, Output, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormModule } from '@shared/components/form/form.module';
import { CheckboxOption, ReportFilterChange, ReportFiltersParams } from '../../models/report-filters.model';
import { ReportFiltersHelperService } from '../../services/report-filters-helper.service';
import { ReportDictionariesService } from '../../services/report-dictionaries.service';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CheckboxGroupComponent } from '@shared/components/form/components/checkbox-group/checkbox-group.component';

@Component({
  selector: 'stx-gender-filter',
  templateUrl: './gender-filter.component.html',
  imports: [CheckboxGroupComponent]
})
export class GenderFilterComponent extends BaseComponent implements OnInit {
  private reportDictionariesService = inject(ReportDictionariesService);
  private reportFiltersHelperService = inject(ReportFiltersHelperService);
  private route = inject(ActivatedRoute);

  @Input() formGroupReference: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<ReportFilterChange>();
  genderOptions: CheckboxOption[];
  genderInitialParams: string[] = [];

  ngOnInit() {
    this.genderOptions = this.getCheckboxGroupOptions();
    this.reportFiltersHelperService.addCheckboxGroupOptionsToFormGroup(this.formGroupReference, this.genderOptions);
    this.watchFilterChanges();
    this.watchQueryParamsChange();
  }

  private getCheckboxGroupOptions(): CheckboxOption[] {
    return this.reportFiltersHelperService.getCheckboxGroupOptionsFromDictionary(this.reportDictionariesService.dictionaries.genders);
  }

  private emitFilterModel(change: Record<string, boolean>): void {
    const selectedGenders = this.reportFiltersHelperService.getSelectedCheckboxOptions(change);

    this.filterChange.emit({
      filterName: 'genders',
      payload: {
        genders: selectedGenders
      }
    });
  }

  private watchFilterChanges() {
    if (this.formGroupReference) {
      this.subSink.sink = this.formGroupReference.valueChanges.subscribe(this.emitFilterModel.bind(this));
    }
  }

  private watchQueryParamsChange() {
    this.subSink.sink = this.route.queryParams
      .pipe(filter((params: ReportFiltersParams) => !!params.genders?.length))
      .subscribe((params: ReportFiltersParams) => {
        this.reportFiltersHelperService.setCheckboxFormGroupValues(this.formGroupReference, params.genders);
      });
  }
}

@NgModule({
  imports: [FormModule, GenderFilterComponent],
  exports: [GenderFilterComponent]
})
export class GenderPickerModule {}
